<template>
    <Modal
        :title="$t('modalAutojoined.title')"
        :cancel-text="$t('modalAutojoined.cancelText')"
        @cancel="onCancel"
        @submit="() => close(true)"
    >
        <template #content>
            <i18next :translation="$t('modalAutojoined.text')">
                <template #courseName>
                    <b>{{ course.name }}</b>
                </template>
            </i18next>
            <br /><br />
            {{ $t('modalAutojoined.suggestLeave') }}
        </template>
    </Modal>
</template>

<script>
import Modal from '@components/Modal';
import ModalMixin from '@mixins/modalMixin';
import { pushGtmEvent, GtmEventName } from '@/utils/gtmUtils';

export default {
    name: 'ModalCourseAutoJoined',
    components: {
        Modal,
    },
    extends: ModalMixin,
    i18nOptions: {
        namespaces: ['document'],
    },
    props: {
        /** Object with id & name attribute */
        course: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async onCancel() {
            await this.$store.dispatch('course/leave', {
                course: this.course,
                keepFollowedDocuments: true,
            });
            pushGtmEvent(GtmEventName.LEAVE_COURSE);
            this.close(false);
        },
    },
};
</script>
